/**
 * Bunny Stream player URLs. A video reaches the content either as a share link pasted by hand or
 * picked from the media library, and the client parsers render whatever `embed` URL was stored -
 * so every producer has to build the exact same one. Hence a single home for it.
 */
export const BUNNY_PLAYER_PARAMS = "autoplay=false&loop=false&muted=false&preload=true&responsive=true";

export const createBunnyEmbedUrl = (libraryId: number | string, videoId: string) =>
  `https://iframe.mediadelivery.net/embed/${libraryId}/${videoId}?${BUNNY_PLAYER_PARAMS}`;

/** The link Bunny's dashboard offers for sharing - kept as `source` on the embed block. */
export const createBunnyPlayUrl = (libraryId: number | string, videoId: string) =>
  `https://iframe.mediadelivery.net/play/${libraryId}/${videoId}`;

export interface Caption {
  srclang: string;
  label: string;
}

export interface Chapter {
  title: string;
  start: number;
  end: number;
}

export interface Moment {
  label: string;
  timestamp: number;
}

export interface MetaTag {
  property: string;
  value: string;
}

export type BunnyResolutions = "360p" | "480p" | "720p" | "240p" | "1080p" | "1440p" | "2160p";

export interface BunnyVideoObject {
  videoLibraryId: number;
  guid: string;
  title: string;
  dateUploaded: Date;
  views: number;
  isPublic: boolean;
  length: number;
  status: number;
  framerate: number;
  width: number;
  height: number;
  availableResolutions: string | null;
  thumbnailCount: number;
  encodeProgress: number;
  storageSize: number;
  captions: Caption[];
  hasMP4Fallback: boolean;
  collectionId: string;
  thumbnailFileName: string;
  averageWatchTime: number;
  totalWatchTime: number;
  category: string;
  chapters: Chapter[];
  moments: Moment[];
  metaTags: MetaTag[];
}

export interface BunnyVideoCollection {
  videoLibraryId: number;
  videoCount: number;
  totalSize: number;
  guid: string;
  name: string;
}
